import React from "react";
import "./footer.css";
import {
  IconMailFilled,
  IconMapPinFilled,
  IconPhoneFilled,
} from "@tabler/icons-react";

const Footer = () => {
  return (
    <footer className="footer py-4 px-6 sm:p-6 bg-[#4e1c4e] sticky top-[100vh] text-gray-100">
      <div className="mx-auto">
        <div className="md:flex md:justify-between md:mr-10">
          <div className="mb-6 md:mb-0">
            <p className="mt-4 md:max-w-[500px]">
              Receive GIFTS directly from your followers and funs.No sharing your number and no high platform fees. Just seamless M-PESA payments via your unique payment link pinned to your posts, live streaming or bio, so you get rewarded instantly and safely. 
              Let your funs Gift you Seamlessly.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
            <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-[#e9b22c]">
                Contact Us
              </h2>
              <ul className="">
                <li className="mb-4 flex items-center gap-1">
                  <IconPhoneFilled size={16} />
                  <a href="tel:+254700638660" className="text-sm">
                    +254 700 638 660
                  </a>
                </li>
                <li className="mb-4 flex items-center gap-1">
                  <IconMailFilled size={16} />
                  <a href="mailto:hello@tipsource.io" className="text-sm">
                    hello@tipsource.io
                  </a>
                </li>
                <li className="flex items-center gap-1">
                  <IconMapPinFilled size={16} />
                  <a href="mailto:hello@tipsource.io" className="text-sm">
                    Nairobi, Kenya
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-[#e9b22c]">
                Legal
              </h2>
              <ul className="">
                <li className="mb-4">
                  <a href="/privacy" className="hover:underline">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/terms" className="hover:underline">
                    Terms &amp; Conditions
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-[#e9b22c]">
                Follow Us
              </h2>
              <ul className="text-sm">
                <li className="mb-2">
                  <a
                    href="https://www.facebook.com/profile.php?id=61564862432822"
                    target="_blank"
                    className="flex gap-1 items-center"
                    rel="noreferrer"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="#4267B2"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.1006 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="text-xs">Tipserve</span>
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="https://www.instagram.com/tipsource__"
                    target="_blank"
                    className="flex gap-1 items-center"
                    rel="noreferrer"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="#E1306C"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.1004.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.1004.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.1005-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.1005-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="text-xs">Tipsource__</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://x.com/Tipsource_?t=nx78S0nGynxuo5yyg8lC2w&s=08"
                    target="_blank"
                    className="flex gap-1 items-center"
                    rel="noreferrer"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="#1DA1F2"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                    <span className="text-xs">Tipsource_</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="my-6 border-gray-100 sm:mx-auto lg:my-8" />
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-sm sm:text-center">
            © 2024{" "}
            <a href="#" className="hover:underline">
              Tipserve™
            </a>
            . All Rights Reserved.
          </span>
          <div className="flex mt-4 mr-8 space-x-6 sm:justify-center sm:mt-0"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
